import { render } from "./BuyerQuoteDetails.vue?vue&type=template&id=726862f2&lang=html"
import script from "./BuyerQuoteDetails.vue?vue&type=script&lang=js"
export * from "./BuyerQuoteDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__